import * as React from 'react';

function SvgAustralia(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.73h35.537V0H0v20.73z"
        fill="#180087"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.346 12.7l.546 1.685 1.65-.626-.975 1.471 1.517.901-1.758.154.241 1.748-1.221-1.279-1.213 1.279.243-1.748-1.762-.154 1.52-.9-.978-1.472 1.654.626.536-1.684zM28.043 15.728l.262.802.786-.297-.463.701.721.43-.841.071.12.832-.585-.61-.575.61.115-.832-.837-.072.722-.429-.463-.7.786.296.252-.802zM23.373 8.328l.256.8.785-.298-.462.703.722.429-.839.07.117.834-.58-.61-.58.61.116-.835-.838-.07.721-.428-.462-.703.785.298.259-.8zM28.043 3.263l.262.802.786-.297-.463.7.721.43-.841.072.12.831-.585-.607-.575.607.115-.83-.837-.074.722-.43-.463-.699.786.297.252-.802zM32.203 7.082l.254.8.792-.297-.469.7.726.428-.841.074.12.834-.582-.61-.579.61.117-.834-.84-.074.723-.427-.463-.701.786.298.256-.801zM29.916 10.831l.204.5.536.04-.41.346.127.525-.457-.286-.455.286.126-.525-.411-.347.538-.039.202-.5zM7.792 0v3.118H0v3.116h7.792v3.117h3.112V6.234h7.797V3.118h-7.797V0H7.792z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0v1.045L16.608 9.35h2.089V8.305L2.09 0H0z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.608 0L0 8.305v1.046h2.09l16.607-8.306V0h-2.089z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.413 0v3.74H0v1.87h8.413v3.741h1.87v-3.74h8.414V3.74h-8.414V0h-1.87z"
        fill="#EA0020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.304 0l-6.231 3.118h1.394L18.697 0h-1.393zM0 0v.698l4.835 2.42h1.399L0 0zM12.467 6.234l6.235 3.117v-.698l-4.842-2.42h-1.393zm-6.234 0L0 9.35h1.394l6.233-3.117H6.233z"
        fill="#EA0020"
      />
    </svg>
  );
}

export default SvgAustralia;
